module.exports = __webpack_public_path__ + "static/media/8.98cf4abf.jpg";